import React, { useState, useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ContainerAccordion, { AccordionDetails, AccordionSummary } from './ContainerAccordion';
import { CircularProgress, Typography } from '@material-ui/core';
import DeviceInfo from './DeviceInfo';
import BreathingText from './BreathingText';
import Collapse from '@material-ui/core/Collapse'

const Rlc = ({
    name,
    data,
    vsId,
    rlcId,
    fetchRlc,
}) => {
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        expanded && fetchRlc(vsId, rlcId); //fetchRlc(region, lb, container)
    }, [expanded]);

    return <ContainerAccordion expanded={expanded}>
        <AccordionSummary onClick={() => setExpanded(!expanded)} expandIcon={<ExpandMoreIcon />}>
            <div style={{ display: 'inline-block', overflow:'visible' }}>
                {name}
                {
                    !data['loading'] && 
                        <Typography variant='caption' style={{display:'inline-block',  color:'#979797', marginLeft:'5px', }}>
                            ({data['rlc'][0]})
                        </Typography>
                }
            </div>
            <div style={{ display: 'inline-block' }}>
                {
                    data['loading'] && <CircularProgress size={16} style={{ marginLeft: '10px' }} />
                }
            </div>
            {expanded && !data['loading'] &&
                <div style={{ display: 'inline-block' }}>
                    <Typography variant='caption' style={{display:'inline-block',  color:'#979797'}}>
                            L{data['rlc'][1]}, C{data['rlc'][2]}, 9000
                    </Typography>
                </div>
            }
        </AccordionSummary>
        <AccordionDetails>
            {data['loading'] ? <BreathingText style={{marginLeft:'20px', fontStyle:'italic', fontWeight:'300'}}>Loading...</BreathingText> :
                data['devices'] && data['devices'].map(device =>
                    <Collapse in={true} appear={true} timeout={300}><div>
                    <ContainerAccordion defaultExpanded={device.connection_state === 'Connected'}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {device['device_id']}
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                        
                            <div style={{marginTop:'-8px', paddingLeft:'35px'}}>
                               
                                    <DeviceInfo device={device} />
                                
                            </div>
                            
                            
                        </AccordionDetails>
                    </ContainerAccordion>
                    </div></Collapse>
                )}
            
        </AccordionDetails>
    </ContainerAccordion>
    


}

export default Rlc;